/*
 * Copyright (C) America Móvil S.A.B de C.V - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Juan Manuel Garcia Junco Moreno <manue.garcia@ironbit.com.mx>, March 2020
 */

/**
 * Available queue statuses.
 */
export enum QueueStatus {
    IDLE = 'idle',
    PROCESSING = 'processing'
}

/**
 * Available task status.
 */
export enum TaskStatus {
    IDLE = 'idle',
    FAILED = 'failed',
    SUCCESS = 'success'
}

export const DEFAULT_RETRIES = 3;
export const DEFAULT_BACKOFF = 500;
export const DEFAULT_INTERVAL = 250;
// Five minutes.
export const DEFAULT_MAX_AGE = 300000;
export const DEFAULT_CONCURRENCY = 20;



// WEBPACK FOOTER //
// ./src/packages/core/lib/queue/constants.ts